import ChooseUsHeading from "../../images/home/choose-us-heading.png";
import ChooseUsShape from "../../images/home/choose-us-shape.png";

function ChooseUs() {
  return (
    <div className="home-choose-us">
      <div className="heading">
        <img src={ChooseUsHeading} alt="heading" />
        <p>Why choose us</p>
      </div>
      <div className="stack">
        <div className="stack1">
          <div />
          <h2 className="stack-heading">Ambitious team</h2>
          <p className="stack-body">
            We recruit intellectually active, flexible and self motivating
            individuals, who thrive on change and challenge, who are innovative,
            confident and don't shy away from responsibilities.
          </p>
        </div>
        <div className="stack2">
          <div />
          <h2 className="stack-heading">Practical Solutions</h2>
          <p className="stack-body">
            We don't overbuild or upsell. Every feature is designed to serve a
            real need in your business. That means less waste, faster delivery,
            and software that actually works the way you need it to.
          </p>
        </div>
        <div className="stack3">
          <div />
          <h2 className="stack-heading">Direct Support</h2>
          <p className="stack-body">
            You'll always speak with someone who knows your project — not a
            chatbot or third-party rep. Our team is hands-on, responsive, and
            invested in making sure things run smoothly from day one.
          </p>
        </div>
        <div className="stack4">
          <div />
          <h2 className="stack-heading">Ongoing Partnerships</h2>
          <p className="stack-body">
            Our work doesn't stop at launch. We stay involved to fix issues,
            roll out updates, and help your systems grow with your business —
            without surprise costs or long waits.
          </p>
        </div>
      </div>
      <img src={ChooseUsShape} alt="shape" className="bg-image" />
    </div>
  );
}

export default ChooseUs;
